module.exports = __webpack_public_path__ + "static/media/vegitables_58.165dc0b1.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/vegitables/vegitables_58.csv
// module id = 644
// module chunks = 0